import { Skeleton } from "@particles/index"

import { PriorityIcon } from "@atoms"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import { JobPreviewPriorityProps } from "./JobPreviewPriority.types"

export default function JobPreviewPriority(props: JobPreviewPriorityProps) {
    const { priority } = props
    const { isLoading } = useJobPreviewCard()

    if (isLoading && priority === undefined) {
        return <Skeleton width={16} height={16} circle={true} />
    }

    return <PriorityIcon priority={priority ?? null} size={8} />
}
